import { Component, OnInit } from '@angular/core';
import { GlobalSettingsService } from '../../../../services/ui/global-settings.service';
import {ActivatedRoute} from '@angular/router';
import {BinderSessionStatus} from '../../../../models/binder/binder-session-confirmation-response.model';

@Component({
  selector: 'binder-session-status',
  templateUrl: './binder-session-status.component.html',
  styleUrls: ['./binder-session-status.component.scss']
})
export class BinderSessionStatusComponent implements OnInit {
  public binderSessionConfirmationStatus: BinderSessionStatus;
  public statusLabels: { text: string | Date, class: string }[] = [];

  constructor(
      private activatedRoute: ActivatedRoute
  ) { }
  ngOnInit(): void {
    this.binderSessionConfirmationStatus = this.activatedRoute.snapshot.data.BinderSessionStatusResolver;
    this.setStatusLabels();
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
  }

  private setStatusLabels(): void {
    this.statusLabels = [];

    const { isDeactivated, isArchived, expiresOn , isLive, isExpired} = this.binderSessionConfirmationStatus;
    const now = new Date();


    if (this.binderSessionConfirmationStatus === null) {
        this.statusLabels.push({ text: 'NOT FOUND', class: 'label-red' });
        return;
    }

    if (isLive) {
      if (expiresOn) {
        this.statusLabels.push({ text: expiresOn, class: 'label-green' });
      } else {
        this.statusLabels.push({ text: 'ACTIVE', class: 'label-green' });
      }
    }


    if (!isLive) {
      if (isDeactivated) {
        this.statusLabels.push({ text: 'DEACTIVATED', class: 'label-red' });
      }

      if (isArchived) {
        this.statusLabels.push({ text: 'ARCHIVED', class: 'label-gray' });
      }

      if (isExpired) {
        this.statusLabels.push({ text: 'EXPIRED', class: 'label-red' });
      }
    }
  }

  isDate(value: any): value is Date {
    return value instanceof Date && !isNaN(value.getTime());
  }

}
